import { Box, Button, Stack, Typography } from "~/common/mui";
import { useFormContext } from "react-hook-form";
import type { MediaFormFields } from "~/features/mediaLibrary/types/mediaLibraryFormTypes";
import { IMG_NO_RESULTS_OR_MATCHES } from "~/utils/url/staticResources";
import { useTranslation } from "react-i18next";

export default function NoMediaFound() {
  const { watch, reset } = useFormContext<MediaFormFields>();
  const fetchFavourite = watch("fetchFavourite");
  const { t } = useTranslation();

  return (
    <Stack direction="column" alignItems="center" justifyContent="center" width={1}>
      <Typography variant="headlineLarge" fontWeight={400} color="text.primary" sx={{ mt: 7 }}>
        {fetchFavourite ? t("media.library.noFavouritesFound") : t("media.library.noMatchesFound")}
      </Typography>
      <Typography variant="bodyLarge" fontWeight={400} color="text.primary" textAlign="center" sx={{ mt: 2 }}>
        {t("media.library.noMatchesTryAgain")}
      </Typography>
      <Box
        component="img"
        src={IMG_NO_RESULTS_OR_MATCHES}
        alt={t("media.library.filterLabel.imageError")}
        sx={{ height: "280px" }}
      />
      <Button variant="text" sx={{ mt: 2 }} onClick={() => reset()}>
        {fetchFavourite ? t("media.library.backToLibrary") : t("media.library.resetFilters")}
      </Button>
    </Stack>
  );
}
